const last2Precision = new RegExp(/^[-]?[0-9]+([.]\d{1,2})?$/);
const last4Precision = new RegExp(/^[-]?[0-9]+([.]\d{1,4})?$/);

const emailReg = new RegExp(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/);

const sslValid = new RegExp(
  /^(-----BEGIN CERTIFICATE-----[\s\S]+-----END CERTIFICATE-----)$/,
);

//sslkey 匹配12种格式UXPSA-12862
const sslKeyValid = new RegExp(
  /^(-----*\s*BEGIN\s*(RSA|EC|DSA|OPENSSH|PGP|SSH2\sENCRYPTED|GOST|SPKI|ENCRYPTED|PUBLIC)?\s*PRIVATE\s*KEY(?:\s*BLOCK)?\s*-*\s*[\s\S]+[\s\S]*\s*-*\s*END\s*\2?\s*PRIVATE\s*KEY(?:\s*BLOCK)?\s*-*$|-----*\s*BEGIN\s*PKCS7\s*-*\s*[\s\S]+[\s\S]*\s*-*\s*END\s*PKCS7\s*-*$)$/,
);

const domainValid = new RegExp(
  /^(?![a-zA-Z0-9-]{1,63}\.[a-zA-Z]{2,}$)(?!-)(xn--)?[a-zA-Z0-9-]{1,63}(\.[a-zA-Z0-9-]{1,63})*(\.[a-zA-Z]{2,}|\.[a-zA-Z0-9-]{2,}\.[a-zA-Z]{2,}(\.[a-zA-Z]{2,})?)$/,
);

const rootDomainValid = new RegExp(/^[a-zA-Z0-9-]{1,63}\.[a-zA-Z]{2,}$/);

const emailPIIReg = new RegExp(/^(.{2}).*(@.*)$/);

const urlReg = new RegExp(
  /(http|https):\/\/[\w\-_]+(\.[\w\-_]+)+([\w\-\.,@?^=%&:/~\+#]*[\w\-\@?^=%&/~\+#])?/,
);
export {
  last2Precision,
  last4Precision,
  emailReg,
  sslValid,
  sslKeyValid,
  domainValid,
  emailPIIReg,
  rootDomainValid,
  urlReg,
};
